import { Encoding, Guide, MarkTransform, MarkType } from '@mode-vegas/vegas';
import { EncodingHelpers } from '../..';
import { ChartTranslator } from '../chart-translator';

export class Area100Translator implements ChartTranslator {
  translateHighChartsToMuze(encoding: Encoding): Encoding {
    const guide = new Guide();
    // 100% Area uses TotalArea as the MarkType in Quick Charts.
    // This is not a valid mark type in VE.
    // Switch to Area.
    encoding = guide.updateMarkType(encoding, MarkType.Area).encoding;

    // Set the transform to Stack100Percent
    encoding = EncodingHelpers.updateMarkOptions(encoding, {
      type: MarkType.Area,
      transform: MarkTransform.Stack100Percent,
    }).encoding;

    return encoding;
  }

  translateMuzeToHighCharts(encoding: Encoding): Encoding {
    const guide = new Guide();
    // Change the MarkType back to TotalArea
    encoding = guide.updateMarkType(encoding, MarkType.TotalArea).encoding;
    return encoding;
  }

  formatRequiresEncodingUpdate(): boolean {
    return false;
  }
}
